import { Route, Routes } from "react-router-dom";
import Layout from './layout/Layout.jsx'
import Center from "./pages/Center.jsx";
import Amortizatorner from "./pages/Amortizatorner.jsx";
import Pnevmo from "./pages/Pnevmo.jsx";
import Compressor from "./pages/Compressor.jsx";
import Airbalone from "./pages/Airbalone.jsx";



function App() {
  let image = [
    {
      image: "image/a.jpg",
      anun: 'Ամորտիզատոր',
      gin: "25.000 դրամ"



    }, {
      image: "image/b.jpg",
      anun: 'Ամորտիզատոր',
      gin: "46.000 դրամ"



    }, {
      image: "image/c.jpg",
      anun: 'Ամորտիզատոր',
      gin: "48.000 դրամ"



    }, {
      image: "image/d.jpg",
      anun: 'Ամորտիզատոր',
      gin: "35.000 դրամ"



    }, {
      image: "image/i.jpg",
      anun: 'Ամորտիզատոր',
      gin: "94.000 դրամ"



    }, {
      image: "image/f.jpg",
      anun: 'Ամորտիզատոր',
      gin: "135.000 դրամ"



    }, {
      image: "image/j.jpg",
      anun: 'Ամորտիզատոր',
      gin: "55.000 դրամ"



    }, {
      image: "image/g.jpg",
      anun: 'Ամորտիզատոր',
      gin: "35.000 դրամ"



    }, {
      image: "image/k.jpg",
      anun: 'Ամորտիզատոր',
      gin: "75.000 դրամ"



    }, {
      image: "image/l.jpg",
      anun: 'Ամորտիզատոր',
      gin: "67.000 դրամ"



    }, {
      image: "image/m.jpg",
      anun: 'Ամորտիզատոր',
      gin: "44.000 դրամ"



    }, {
      image: "image/n.jpg",
      anun: 'Ամորտիզատոր',
      gin: "96.000 դրամ"



    }, {
      image: "image/o.jpg",
      anun: 'Ամորտիզատոր',
      gin: "58.000 դրամ"



    }, {
      image: "image/p.jpg",
      anun: 'Ամորտիզատոր',
      gin: "78.000 դրամ"



    },
    {
      image: "image/face3.jpg",
      anun: 'Ամորտիզատոր',
      gin: "78.000 դրամ"



    }, {
      image: "image/face2.jpg",
      anun: 'Ամորտիզատոր',
      gin: "78.000 դրամ"



    }, {
      image: "image/face1.jpg",
      anun: 'Ամորտիզատոր',
      gin: "78.000 դրամ"



    }
  ]


























  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Center />} />
          <Route path="/amortization" element={<Amortizatorner image={image} />} />
          <Route path="/pnevmo" element={<Pnevmo image={image} />} />
          <Route path="/compressor" element={<Compressor image={image} />} />
          <Route path="/airbalone" element={<Airbalone image={image} />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
